module.exports = function getResource(label, vars = []) {
    const resources = { freeShipping: 'Free Shipping' };
    return resources[label];
};
